module.exports = __webpack_public_path__ + "img/park-troopers.b3a17b2b.jpg";